module.exports = __webpack_public_path__ + "img/installation-6.6ee9e12d.png";